import React from "react";
import Interval from "react-interval-timer";

import StateContext from "../contexts/State";

const ToggleWidgetVisibility = ({ interval, actions }) => (
  <Interval
    timeout={interval}
    enabled
    repeat
    callback={actions.toggleWidgetVisibility}
  />
);

const ToggleWidgetVisibilityContainer = () => (
  <StateContext.Consumer>
    {({ selectors, actions }) => (
      <ToggleWidgetVisibility
        interval={selectors.getVisibilityInterval()}
        actions={actions}
      />
    )}
  </StateContext.Consumer>
);

export default ToggleWidgetVisibilityContainer;
